import React, { useState, useEffect } from "react";
import ajax from "superagent";
const doNotPhotographIcon = require("../styles/images/redacted.svg");

interface DoNotPhotographPerson {
  id: number;
  ext_id: string;
  name: string;
  photo_url?: string;
}

const DoNotPhotographPanel: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [people, setPeople] = useState<DoNotPhotographPerson[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchDoNotPhotographList();
  }, []);

  const fetchDoNotPhotographList = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await ajax.get(`/api/v1/do_not_photograph_participants`);
      setPeople(response.body.master_participants || []);
    } catch (err: any) {
      console.error("Failed to fetch 'Do Not Photograph' list:", err);
      setError("Failed to load 'Do Not Photograph' list.");
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  // Don't render until loaded with people
  if (loading || people.length === 0) {
    return null;
  }

  return (
    <div className="do-not-photograph-panel">
      {/* Collapsed/Expandable Header Bar */}
      <button
        type="button"
        className="do-not-photograph-panel__header"
        onClick={handleToggle}
        aria-expanded={isExpanded}
        aria-label={`${
          isExpanded ? "Collapse" : "Expand"
        } 'Do Not Photograph' list`}
      >
        <div className="do-not-photograph-panel__header-left">
          <img src={doNotPhotographIcon} alt="" aria-hidden="true" />
          <span className="do-not-photograph-panel__label">
            View 'Do Not Photograph' list{" "}
          </span>
        </div>
        <i
          className={`fas fa-chevron-down do-not-photograph-panel__chevron ${
            isExpanded ? "do-not-photograph-panel__chevron--expanded" : ""
          }`}
          aria-hidden="true"
        ></i>
      </button>

      {/* Expandable Content */}
      <div
        className={`do-not-photograph-panel__content ${
          isExpanded ? "do-not-photograph-panel__content--expanded" : ""
        }`}
        aria-hidden={!isExpanded}
      >
        <div className="do-not-photograph-panel__inner">
          {error && (
            <div className="do-not-photograph-panel__error">
              <i className="fas fa-exclamation-triangle mr-2"></i>
              {error}
              <button
                className="btn btn-link btn-sm ml-2 p-0"
                onClick={fetchDoNotPhotographList}
              >
                Try Again
              </button>
            </div>
          )}

          {!error && (
            <div className="do-not-photograph-panel__scroll-container">
              {people.map(person => (
                <div key={person.id} className="dnp-thumbnail">
                  <div className="dnp-thumbnail__image">
                    {person.photo_url ? (
                      <img
                        src={person.photo_url}
                        alt={person.name}
                        onError={e => {
                          const target = e.target as HTMLImageElement;
                          target.style.display = "none";
                          const placeholder =
                            target.nextElementSibling as HTMLElement;
                          if (placeholder) {
                            placeholder.style.display = "flex";
                          }
                        }}
                      />
                    ) : null}
                    <div
                      className="dnp-thumbnail__placeholder"
                      style={{ display: person.photo_url ? "none" : "flex" }}
                    >
                      <i className="fas fa-user-slash"></i>
                    </div>
                  </div>
                  <div className="dnp-thumbnail__name">
                    {person.name}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DoNotPhotographPanel;
